export default __webpack_public_path__ + "static/media/icon-search.055aad98.svg";